export default "__VITE_ASSET__B8D3M6s7__"